
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-x-stream-demo-default-protocol","docs-x-sdk-x-stream-demo-custom-protocol"],
  getter: () => import(/* webpackChunkName: "meta__docs__zh-CN" */'/opt/buildhome/repo/packages/x/docs/x-sdk/x-stream.zh-CN.md?type=demo')
};